import { render, staticRenderFns } from "./ExistingLpaType.vue?vue&type=template&id=121aaab6"
import script from "./ExistingLpaType.vue?vue&type=script&lang=js"
export * from "./ExistingLpaType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports